import React from "react";
import ContentManager from "./ContentManager";

const STATUS_OPTS = ["draft", "in_review", "approved", "published", "archived"];

export function AdminSystems() {
  return <ContentManager
    resource="systems"
    label="System"
    listColumns={[
      { name: "name", label: "Name" },
      { name: "short_name", label: "Short name" },
      { name: "slug", label: "Slug" },
      { name: "status", label: "Status" },
    ]}
    fields={[
      { name: "slug", label: "Slug (URL)" },
      { name: "name", label: "Name (Mini / Standard / Pro)" },
      { name: "short_name", label: "Short name" },
      { name: "title", label: "Full title" },
      { name: "hero_statement", label: "Hero statement", type: "textarea", rows: 2 },
      { name: "summary", label: "Summary", type: "textarea", rows: 4 },
      { name: "features", label: "Features (one per line)", type: "list" },
      { name: "best_uses", label: "Best uses (one per line)", type: "list" },
      { name: "deployment_requirements", label: "Deployment requirements", type: "textarea" },
      { name: "monitoring_options", label: "Monitoring options", type: "textarea" },
      { name: "storage_details", label: "Storage", type: "textarea" },
      { name: "image", label: "Image URL" },
      { name: "status", label: "Status", type: "select", options: STATUS_OPTS },
    ]}
  />;
}

export function AdminIndustries() {
  return <ContentManager
    resource="industries"
    label="Industry"
    listColumns={[
      { name: "title", label: "Title" },
      { name: "slug", label: "Slug" },
      { name: "status", label: "Status" },
    ]}
    fields={[
      { name: "slug", label: "Slug" },
      { name: "title", label: "Title" },
      { name: "short", label: "Short label" },
      { name: "summary", label: "Summary", type: "textarea" },
      { name: "risks", label: "Common risks (one per line)", type: "list" },
      { name: "recommended_systems", label: "Recommended systems (slugs, one per line)", type: "list" },
      { name: "image", label: "Image URL" },
      { name: "status", label: "Status", type: "select", options: STATUS_OPTS },
    ]}
  />;
}

export function AdminServices() {
  return <ContentManager
    resource="services"
    label="Service"
    listColumns={[
      { name: "title", label: "Title" },
      { name: "slug", label: "Slug" },
      { name: "status", label: "Status" },
    ]}
    fields={[
      { name: "slug", label: "Slug" },
      { name: "title", label: "Title" },
      { name: "summary", label: "Summary", type: "textarea" },
      { name: "problem", label: "Problem", type: "textarea" },
      { name: "how_it_works", label: "How it works", type: "textarea" },
      { name: "systems", label: "Related systems (slugs, one per line)", type: "list" },
      { name: "status", label: "Status", type: "select", options: STATUS_OPTS },
    ]}
  />;
}

export function AdminCities() {
  return <ContentManager
    resource="cities"
    label="City"
    listColumns={[
      { name: "title", label: "City" },
      { name: "state_name", label: "State" },
      { name: "service_status", label: "Service" },
      { name: "status", label: "Publish status" },
    ]}
    fields={[
      { name: "slug", label: "Slug" },
      { name: "title", label: "City name" },
      { name: "state_slug", label: "State slug (nevada / utah)" },
      { name: "state_name", label: "State display" },
      { name: "summary", label: "Summary", type: "textarea" },
      { name: "service_status", label: "Service status", type: "select", options: ["active", "limited", "expansion", "inactive"] },
      { name: "status_label", label: "Public status label" },
      { name: "status", label: "Publish status", type: "select", options: STATUS_OPTS },
    ]}
  />;
}

export function AdminArticles() {
  return <ContentManager
    resource="articles"
    label="Article"
    listColumns={[
      { name: "title", label: "Title" },
      { name: "category", label: "Category" },
      { name: "published_date", label: "Published" },
      { name: "status", label: "Status" },
    ]}
    fields={[
      { name: "slug", label: "Slug" },
      { name: "title", label: "Title" },
      { name: "excerpt", label: "Excerpt", type: "textarea", rows: 2 },
      { name: "author", label: "Author" },
      { name: "published_date", label: "Published date" },
      { name: "reading_time", label: "Reading time" },
      { name: "category", label: "Category" },
      { name: "content", label: "Content (markdown / plain)", type: "textarea", rows: 12 },
      { name: "status", label: "Status", type: "select", options: STATUS_OPTS },
    ]}
  />;
}

export function AdminFaqs() {
  return <ContentManager
    resource="faqs"
    label="FAQ"
    listColumns={[
      { name: "question", label: "Question" },
      { name: "category", label: "Category" },
      { name: "status", label: "Status" },
    ]}
    fields={[
      { name: "slug", label: "Slug" },
      { name: "question", label: "Question" },
      { name: "answer", label: "Answer", type: "textarea" },
      { name: "category", label: "Category" },
      { name: "status", label: "Status", type: "select", options: STATUS_OPTS },
    ]}
  />;
}
